import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import type { AdminDealDrawerPayload } from "./use-admin-deal";
import { AccountPanel } from "./account-panel";
import { CollaboratorsPanel } from "./collaborators-panel";
import { DealSummaryPanel } from "./deal-summary-panel";
import { NoPortalYetPanel } from "./no-portal-yet-panel";
import { PartnerSummaryPanel } from "./partner-summary-panel";

// SPA port of DealDrawerContent. The Sheet open/close state is owned by
// the parent <DealDrawer> wrapper — `open` reflects the presence of the
// `?deal=<id>` URL param; `onClose` clears it.

type Props = {
  payload: AdminDealDrawerPayload;
  canManage: boolean;
  open: boolean;
  onClose: () => void;
};

export function DealDrawerContent({
  payload,
  canManage,
  open,
  onClose,
}: Props) {
  return (
    <Sheet
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
    >
      <SheetContent
        side="right"
        className="w-full overflow-y-auto p-0 sm:max-w-[640px]"
      >
        <SheetHeader className="border-b px-6 py-4">
          <SheetTitle className="font-display tracking-tight">
            {payload.deal.deal_name || "(unnamed deal)"}
          </SheetTitle>
          <p className="text-xs text-muted-foreground">
            HubSpot Sales pipeline · read-only snapshot
          </p>
        </SheetHeader>

        <div className="space-y-4 px-6 py-4">
          <PartnerSummaryPanel attributions={payload.attributions} />
          <DealSummaryPanel deal={payload.deal} />
          <NoPortalYetPanel unboardedPartners={payload.unboardedPartners} />
          <CollaboratorsPanel
            hubspotDealId={payload.deal.hubspot_deal_id}
            collaborators={payload.collaborators}
            canManage={canManage}
            owner={payload.owner}
          />
          <AccountPanel
            account={payload.account}
            hubspotDealId={payload.deal.hubspot_deal_id}
            canLink={canManage}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}
